import { IonLabel, IonThumbnail } from '@ionic/react';
import moment from 'moment';
import { useContext, useEffect } from 'react';
import { useHistory } from 'react-router';
import { useWP } from '../../hooks/WPHooks';
import { useLogger } from '../../services/LogService';
import { ModelsService } from '../../services/ModelsService';
import { notifHelper } from '../../services/onesignal/OneSignalService';
import { AppContext } from '../../state/AppContextProvider';
import { ActionType } from '../../state/GlobalState';
import { SanitizeHTML } from '../globals/SanitizeHTML';
import { HouseImgIcon } from '../house/HouseImgIcon';

export const NotifItem = (props: any, key: number) => {
  const { state, dispatch } = useContext(AppContext);

  const { wp } = useWP();

  const history = useHistory();

  const logger = useLogger('NotifItem');

  const notifSender = ModelsService.getHouseTerm(props.sender, state.allHouses);

  const notifSenderThumbnailUrl = ModelsService.getHouseThumbnail(notifSender);

  useEffect(() => {
    if (props.selected) {
      // ensure to remove /notifications/:notifId
      history.push('/notifications');
      setTimeout(clickToSee, 20);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.selected]);

  const updateNotifState = (notifId: number) => {
    const allNotifs = [...state.allNotifs];
    allNotifs.find((notif) => {
      if (notif.id === notifId) {
        notif.acf.state = 'read';
        return true;
      }
      return false;
    });

    dispatch({ type: ActionType.SetAllNotifs, payload: allNotifs });
  };

  const clickToSee = async () => {
    logger.info('clickToSee() state=' + props.state + ', link=' + props.link);

    if (props.state === 'unread') {
      // update in database
      wp.putNotifAcf(props.id, { acf: { state: 'read' } }).then(() =>
        updateNotifState(props.id)
      );
    }

    const internal_link = notifHelper.toInternalLink(props.link);

    if (internal_link !== null) {
      history.push(internal_link);
    } else {
      window.location.assign(props.link);
    }
  };

  const removeTagfromString = (title: string) => {
    let ret = title;
    ret = ret.replace('<p>', '');
    ret = ret.replace('</p>', '');
    ret = ret.replace('\\n', '');
    return ret;
  };

  const title = removeTagfromString(props.title);

  return (
    <li
      key={'notif_' + key}
      className={`cursor-pointer py-4 px-6 flex items-center md:rounded-2xl ${
        props.state === 'unread' ? 'bg-gray-50' : 'bg-white'
      }`}
      onClick={clickToSee}
    >
      <IonThumbnail className="flex-none">
        {notifSender !== undefined ? (
          <img className="rounded-full" src={notifSenderThumbnailUrl} alt="" />
        ) : (
          <HouseImgIcon className="bg-white text-primary rounded-full" />
        )}
      </IonThumbnail>
      <div className="flex-1 pl-4">
        <IonLabel className="">
          <SanitizeHTML
            tag="span"
            className={`text-sm max-w-sm break-words inline-block ${
              props.state === 'unread' && 'font-medium'
            }`}
            html={title.length > 115 ? title.substring(0, 115) + '...' : title}
          />
        </IonLabel>
        <IonLabel>
          <span className={`block text-xs`}>
            {moment(props.date, 'YYYY-MM-DD[T]HH:mm:ss').format('D MMMM')}
          </span>
        </IonLabel>
      </div>
      <div className="flex-none pl-4">
        {props.state === 'unread' ? (
          <div className="h-3 w-3 min-w-max my-auto rounded-full bg-primary" />
        ) : (
          <div className="h-2 w-2 min-w-max my-auto rounded-full bg-lightGrey" />
        )}
      </div>
    </li>
  );
};
